import React from "react";
import { ConvertDateToJalali } from "utils/ConvertDateToJalali";

const useCheckSetTodayOnMount = (
  value,
  disableInit,
  onChange,
  disableToday
) => {
  React.useEffect(() => {
    if (value && !disableInit) {
      onChange && onChange(ConvertDateToJalali(value));
    } else {
      let today = new Date();
      if (disableToday) {
        if (value) {
          if (value?.setHours(0, 0, 0, 0) !== today.setHours(0, 0, 0, 0)) {
            onChange && onChange(ConvertDateToJalali(value));
          }
        }
      } else {
        onChange && onChange(ConvertDateToJalali(value));
      }
    }
  }, [value]);
};

export default useCheckSetTodayOnMount;
